import Model from 'src/app/common/model';
import CultureCategoryModel from './cultureCategory.model';
import FarmSiteModel from './farmSite.model';

export default class SpeciesTypeModel extends Model {
  cultureCategory: CultureCategoryModel;
  FarmSiteDetails: Array<FarmSiteModel>;
  name: string;
  abbreviation?: string;
  seed_provider?: string;
  description?: string;
  culture_category_id: number;
  isActive?: boolean;
  speciesCount: number;
  speciesName: string;
  speciesTypes = new Array();

  constructor() {
    super();
    this.FarmSiteDetails = new Array();
  }
}
